import { useRef } from 'react';
import { FloatingPortal, FloatingOverlay, useMergeRefs } from '@floating-ui/react';
import Box from '../Box/Box';
import maybeDataTestId from '../_internal/utils/maybeDataTestId';
import { useDropdownBase, useElementSize } from './hooks';
import { StyledPopper } from '../Tooltip/Popper/Popper.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function DropdownBase({
  open,
  trigger,
  children,
  onChange,
  disabled = false,
  withScrollLock = false,
  withOverlay = true,
  zIndex = 2000,
  triggerWrapperProps = {
    inline: true
  },
  'data-testid': dataTestId,
  className,
  placement = 'bottom',
  strategy = 'absolute',
  middlewares = [],
  style = {},
  overlayStyle = {}
}) {
  const referenceRef = useRef(null);
  const floatingRef = useRef(null);
  const {
    referenceProps,
    floatingProps
  } = useDropdownBase({
    ref: floatingRef,
    open,
    onChange,
    placement,
    strategy,
    middlewares,
    disabled
  });
  const combinedReferenceRef = useMergeRefs([referenceRef, referenceProps.ref]);
  const {
    width
  } = useElementSize(referenceRef);
  const minWidth = width ? `${width}px` : 'auto';
  const floatingContent = /*#__PURE__*/_jsx(StyledPopper, {
    ...floatingProps,
    className: className,
    style: {
      ...floatingProps.style,
      padding: '8px',
      minWidth,
      ...style,
      zIndex
    },
    ...maybeDataTestId(dataTestId),
    children: children
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      ...triggerWrapperProps,
      ...referenceProps,
      ref: combinedReferenceRef,
      children: trigger
    }), open && /*#__PURE__*/_jsx(FloatingPortal, {
      children: withOverlay ? /*#__PURE__*/_jsx(FloatingOverlay, {
        "data-testid": "backdrop",
        lockScroll: withScrollLock,
        style: {
          ...overlayStyle,
          zIndex: zIndex - 1
        },
        children: floatingContent
      }) : floatingContent
    })]
  });
}
export default DropdownBase;